import Vue from "vue";

const getDefaultState = () => {
	return {
		groups: null,
		selectedGroup: null
	};
};

const Groups = {
	namespaced: true,
	state: getDefaultState(),
	mutations: {
		SET_GROUPS: (state, groups) => {
			state.groups = groups;
		},
		SET_SELECTED_GROUP: (state, selectedGroup) => {
			state.selectedGroup = selectedGroup;
		},
		CREATE_GROUP: () => {
		},
		ADD_USER_TO_GROUP: () => {
		},
		REMOVE_USER_FROM_GROUP: () => {
		},
		UPDATE_GROUP_NAME: () => {
		},
		RESET_STATE: (state) => {
			Object.assign(state, getDefaultState());
		},
	},

	actions: {
		fetchGroups: async ({ commit, rootState }) => {
			if (rootState.User.account.plan_id !== 6) return;

			await Vue.prototype.$apiService
				.get(`accounts/${rootState.User.account.id}/groups`)
				.then((response) => {
					commit("SET_GROUPS", response.data);

					if (rootState.Groups.selectedGroup) {
						const newSelectedGroup = response.data.find(
							(group) =>
								group.id === rootState.Groups.selectedGroup.id
						);

						commit("SET_SELECTED_GROUP", newSelectedGroup);
					}
				})
				.catch((err) => console.log(err.response));
		},

		createGroup: ({ commit, rootState }, name) => {
			return Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/groups`, {
					name,
				})
				.then((response) => {
					commit("CREATE_GROUP", response.data);
				})
				.catch((err) => console.log(err.response));
		},

		addUserToGroup: ({ commit, rootState }, payload) => {
			return Vue.prototype.$apiService
				.post(
					`accounts/${rootState.User.account.id}/groups/${payload.group_id}/account`,
					{
						account_id: payload.account_id,
					}
				)
				.then((response) => {
					commit("ADD_USER_TO_GROUP", response.data);
				})
				.catch((err) => console.log(err.response));
		},

		removeUserFromGroup: ({ commit, rootState }, payload) => {
			return Vue.prototype.$apiService
				.delete(
					`accounts/${rootState.User.account.id}/groups/${payload.group_id}/account`,
					{
						data: {
							account_id: payload.account_id,
						},
					}
				)
				.then((response) => {
					commit("REMOVE_USER_FROM_GROUP", response.data);
				})
				.catch((err) => console.log(err.response));
		},

		updateGroupName: ({ commit, rootState }, payload) => {
			return Vue.prototype.$apiService
				.patch(
					`accounts/${rootState.User.account.id}/groups/${payload.group_id}`,
					{
						name: payload.name,
					}
				)
				.then((response) => {
					commit("UPDATE_GROUP_NAME", response.data);
				})
				.catch((err) => console.log(err.response));
		},
		resetState: ({ commit }) => {
			commit("RESET_STATE");
		},
	},

	getters: {
		getGroup: (state) => (id) => {
			if (state.groups) return state.groups.find((group) => group.id == id);
		},
		selectedGroup: (state) => {
			return state.selectedGroup;
		},
	},
};

export default Groups;
